<template>
  <el-dialog title="绑定机构编码" width="30%" :visible.sync="diaVisible" append-to-body @close="handleClose()">
    <el-form :model="form" label-width="100px" ref="form" style="padding-right: 20px">
      <el-form-item
        label="机构编码:"
        prop="orgCode"
        :rules="{ required: true, message: '请输入该客户对应的机构编码', trigger: 'change' }">
        <el-input v-model="form.orgCode" placeholder="请输入该客户对应的机构编码"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="handleClose()">
      </crm-button>
      <crm-button :text="'确定'" @click="handleSubmit()"></crm-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    CrmButton,
  },
  props: {
    uid: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      diaVisible: false,
      form: {
        orgCode: null,
        uid: this.uid,
      },
    };
  },
  watch: {
    visible(val) {
      this.diaVisible = val;
    },
  },
  methods: {
    ...mapActions({
      bindCode: 'customer/bindCode',
    }),
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.uid = this.uid;
          this.bindCode(this.form).then(() => {
            this.$message.success('绑定成功');
            this.handleClose();
            this.$emit('success');
          });
        }
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>
